module.exports = __webpack_public_path__ + "img/green1.3fd71209.png";